<div *ngIf="show" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60]" (click)="close()">
  <div class="relative top-10 mx-auto p-5 border w-11/12 max-w-5xl shadow-lg rounded-md bg-gray-800" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-200">Selecteer Producten</h3>
        <p *ngIf="getSelectedCount() > 0" class="text-sm text-gray-400 mt-1">
          {{ getSelectedCount() }} product{{ getSelectedCount() !== 1 ? 'en' : '' }} geselecteerd
        </p>
      </div>
      <button
        (click)="close()"
        class="text-gray-400 hover:text-white transition-colors">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="mb-4">
      <div class="relative">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange()"
          placeholder="Zoek op naam, SKU of beschrijving..."
          class="block w-full pl-10 pr-3 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      </div>
    </div>

    <div class="mt-4">
      <!-- Loading State -->
      <div *ngIf="loading" class="flex justify-center items-center py-12">
        <div class="text-gray-400">Producten laden...</div>
      </div>

      <!-- Products List -->
      <div *ngIf="!loading && filteredProducts.length > 0" class="max-h-96 overflow-y-auto space-y-2">
        <div
          *ngFor="let product of filteredProducts"
          (click)="toggleProduct(product.id || '')"
          class="flex items-center space-x-4 p-4 bg-gray-700 rounded-lg cursor-pointer hover:bg-gray-600 transition-colors border border-gray-600 hover:border-indigo-500">
          <!-- Checkbox -->
          <div class="flex-shrink-0">
            <input
              type="checkbox"
              [checked]="isSelected(product.id || '')"
              (click)="$event.stopPropagation(); toggleProduct(product.id || '')"
              class="w-5 h-5 rounded bg-gray-600 border-gray-500 text-indigo-600 focus:ring-indigo-500 focus:ring-2 cursor-pointer">
          </div>

          <!-- Product Image -->
          <div class="flex-shrink-0 w-16 h-16 bg-gray-600 rounded-lg overflow-hidden">
            <img
              *ngIf="getProductImage(product)"
              [src]="getProductImage(product)"
              [alt]="getProductName(product)"
              class="w-full h-full object-cover">
            <div *ngIf="!getProductImage(product)" class="w-full h-full flex items-center justify-center">
              <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
          </div>

          <!-- Product Info -->
          <div class="flex-1 min-w-0">
            <h4 class="text-sm font-medium text-white truncate">{{ getProductName(product) }}</h4>
            <p class="text-xs text-gray-400 mt-1">{{ product.sku }}</p>
            <p *ngIf="getProductDescription(product)" class="text-xs text-gray-500 mt-1 line-clamp-2">
              {{ getProductDescription(product) }}
            </p>
          </div>

          <!-- Price -->
          <div class="flex-shrink-0 text-right">
            <div class="text-sm font-semibold text-indigo-400">
              {{ formatPrice(getProductPrice(product)) }}
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && filteredProducts.length === 0" class="text-center py-12">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
        <p class="mt-2 text-sm text-gray-400">
          {{ searchQuery ? 'Geen producten gevonden voor "' + searchQuery + '"' : 'Geen producten gevonden' }}
        </p>
      </div>
    </div>

    <!-- Footer Actions -->
    <div class="mt-6 flex justify-end space-x-3 border-t border-gray-700 pt-4">
      <button
        (click)="close()"
        class="px-4 py-2 bg-gray-700 text-white text-sm font-medium rounded-md shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
        Annuleren
      </button>
      <button
        (click)="confirmSelection()"
        [disabled]="getSelectedCount() === 0"
        class="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed">
        Selecteren ({{ getSelectedCount() }})
      </button>
    </div>
  </div>
</div>


